import { render } from "./userPrivacy.vue?vue&type=template&id=6b249ca1&scoped=true"
import script from "./userPrivacy.vue?vue&type=script&lang=js"
export * from "./userPrivacy.vue?vue&type=script&lang=js"

import "./userPrivacy.vue?vue&type=style&index=0&id=6b249ca1&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/京南广告/cheyidai/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b249ca1"]])

export default __exports__